<template>
  <div id="404" class="bg-white-500">
    <div class="row justify-content-center align-items-center hv-80">
      <div class="content">
        <div class="letters">
          <svg
            viewBox="0 0 271 319"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="width--responsive"
          >
            <path
              d="M1 268.875V269.875H2H138.227V317V318H139.227H237.434H238.434V317V269.875H269H270V268.875V184.875V183.875H269H238.434V2V1H237.434H132.65H132.131L131.832 1.42508L1.18179 187.363L1 187.621V187.937V268.875ZM146.118 183.875H101.62L146.118 116.035V183.875Z"
              fill="white"
              stroke="#01E5FE"
              stroke-width="2"
            />
          </svg>

          <div class="circle-404"></div>
          <svg
            viewBox="0 0 271 319"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="width--responsive"
          >
            <path
              d="M1 268.875V269.875H2H138.227V317V318H139.227H237.434H238.434V317V269.875H269H270V268.875V184.875V183.875H269H238.434V2V1H237.434H132.65H132.131L131.832 1.42508L1.18179 187.363L1 187.621V187.937V268.875ZM146.118 183.875H101.62L146.118 116.035V183.875Z"
              fill="white"
              stroke="#02C14A"
              stroke-width="2"
            />
          </svg>
        </div>
        <div class="w-100 text-center title-position">
          <router-link to="/" class="button--go__back"
            >Return to Home Page</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404',
};
</script>

<style>
.circle-404 {
  width: 316px;
  border-radius: 50%;
  height: 316px;
  margin: 0px 20px;
  background: linear-gradient(
    141.28deg,
    #00e5ff -2.58%,
    #00e5ff 17.87%,
    #02b718 100.72%
  );
  box-shadow: 0px 10px 50px rgba(172, 172, 172, 0.25);
}

.hv-80 {
  height: 80vh;
}

.letters {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.letters span {
  color: white;
  font-size: 316px;
  margin: 0px 10px;
  font-weight: bolder;
  font-family: 'Tajwaal';
  text-shadow: 0px 10px 50px rgba(172, 172, 172, 0.25);
}

.button--go__back {
  margin-top: 20px;
  color: #bbc1c7;
  text-decoration: unset;
  font-size: 25px;
  text-align: center;
  margin-top: 20px;
  border-bottom: 1px solid #bbc1c7;
  font-size: 36px;
}

.button--go__back:hover {
  text-decoration: unset;
  color: #bbc1c7;
}

.width--responsive {
  width: 217px;
  height: 316px;
}

.title-position {
  position: absolute;
  left: 0;
  margin-top: 30px;
}

@media screen and (max-width: 600px) {
  .width--responsive {
    width: 71px;
  }
  .circle-404 {
    width: 71px;
    height: 71px;
  }
}
</style>
